import convertUsedVehicleToCodeweaversRequest from './ConvertUsedVehicleToCodeweaversRequest';
// import { saveToStorage, getFromStorage } from '../Storage';
import arrayChunk from '../../../modules/arrayChunk';
// import cleansePositiveNumber from '../../../modules/cleansePositiveNumber';
import { financeKeys } from '../../../modules/json/financeKeys';
import GetDefaults from './GetDefaults';
// import getFinance

export default class {
    constructor(options) {
        this.customerRef = '';
        this.deposit = false;
        this.term = false;
        this.valid_terms = [12, 24, 25, 31, 36, 37, 42, 48, 60];
        this.mileage = false;
        this.finance_request = false;
        this.usedVehicles = [];
        this.deposit = GetDefaults.getDefaultDeposit();
        this.term = GetDefaults.getDefaultTerm();
        this.mileage = GetDefaults.getDefaultMileage();
        this.customerRef = '';
        this.collect_only_once = true;

        if (typeof options !== 'undefined') {
            if (typeof options.collect_only_once !== 'undefined') {
                this.collect_only_once = options.collect_only_once;
            }
            if (typeof options.customerRef !== 'undefined') {
                this.customerRef = options.customerRef;
            }
        }
        this.finance_request_template = {
            "Credentials": {
                "ApiKey":"ONH75GHd8x0gu6yfJ6"
            },
            "Customer": {
                "Reference": this.customerRef
            },
            "Parameters": {
                "Term": this.term,
                "Deposit": this.deposit,
                "DepositType": "Amount",
                "AnnualMileage": this.mileage,
                "DisableCalculationCapping": true,
            },
            "VehicleRequests": []
        };
        this.keys = {
            "used": [
                financeKeys.HP,
                financeKeys.PSA_PCP_ONLY,
                financeKeys.VAUXHALL_PCP_ONLY,
                financeKeys.DSG_PCP_ONLY,
            ],
            "new": [
                financeKeys.HP,
                financeKeys.OVERAGE_PCP_ONLY,
            ],
        };
        // this.cleanFinance();
    }

    setKeys(keys) {
        this.keys = keys;
    }

    // cleanFinance() {
    //     this.deposit = cleansePositiveNumber(this.deposit, 2315);
    //     this.mileage = cleansePositiveNumber(this.mileage, 10000);
    //     this.term = cleansePositiveNumber(this.term, 48);
    // }


    setTerm(term) {
        this.term = term;
        this.finance_request_template.Parameters.Term = term;
    }

    setDeposit(deposit) {
        this.deposit = deposit;
        this.finance_request_template.Parameters.Deposit = deposit;
    }

    setMileage(mileage) {
        this.mileage = mileage;
        this.finance_request_template.Parameters.AnnualMileage = mileage;
    }

    setVehicles(usedVehicles) {
        // Using JSON parse/stringify to clone the object without referencing the original, which was causing reactivity issues.
        this.usedVehicles = JSON.parse(JSON.stringify(usedVehicles));
    }

    updateVehicleById(id, data) {
        for (let i = 0; i < this.usedVehicles.length; i++) {
            if (typeof this.usedVehicles[i] !== 'undefined' && this.usedVehicles[i].id == id) {
                Object.assign(this.usedVehicles[i], data);
            }
        }
    }

    setVehicleAsFailed(id) {
        for (let i = 0, len = this.usedVehicles.length; i < len; i++) {
            if (typeof this.usedVehicles[i] !== 'undefined' && this.usedVehicles[i].id == id) {
                this.usedVehicles[i].finance = false;
            }
        }
    }

    getFinanceRequests() {
        // Sometimes we only want to collect finance once for the vehicle, so get an array of vehicles that need finance updating
        let vehiclesToCollectFinanceFor = this.usedVehicles.filter(vehicle => {
            if (typeof vehicle.vat_price == 'undefined') {
                return false;
            }
            // Only collect finance once by default
            return (!this.collect_only_once || !vehicle.finance) ? true : false;
        });

        // Some vehicles will have more than 1 request associated with them, so get all of the requests into 1 giant array first
        let usedVehicleRequests = [];
        for (let i = 0, len = vehiclesToCollectFinanceFor.length; i < len; i += 1) {
            // Don't include Halo Offer finance requests in main request because of varying deposit/mileage/term compared to rest of the results
            // if (vehiclesToCollectFinanceFor[i].is_halo_offer == 1) {
            //     continue;
            // }
            usedVehicleRequests.push(...convertUsedVehicleToCodeweaversRequest(vehiclesToCollectFinanceFor[i], this.keys));
        }
        let chunkedVehicles = arrayChunk(usedVehicleRequests, 12);

        // And then split those requests into chunks of 12
        let financeRequests = [];
        for (let i = 0, len = chunkedVehicles.length; i < len; i += 1) {
            financeRequests[i] = JSON.parse(JSON.stringify(this.finance_request_template));

            for (let j = 0, len2 = chunkedVehicles[i].length; j < len2; j += 1) {
                financeRequests[i].VehicleRequests.push(chunkedVehicles[i][j]);
            }

            // Duplicate the Parameters into any vehicle override requests
            if (financeRequests[i].VehicleRequests.length > 0) {
                financeRequests[i].VehicleRequests.forEach((vehicleRequest, vehicleRequestIndex) => {
                    if (typeof vehicleRequest.Products == 'undefined') {
                        return;
                    }
                    if (vehicleRequest.Products.length == 0) {
                        return;
                    }
                    vehicleRequest.Products.forEach((product, productIndex) => {
                        if (typeof product.OverrideFinanceParameters == 'undefined') {
                            return;
                        }
                        if (typeof product.OverrideFinanceParameters.Term == 'undefined') {
                            financeRequests[i].VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.Term = financeRequests[i].Parameters.Term;
                        }
                        if (typeof product.OverrideFinanceParameters.Deposit == 'undefined') {
                            financeRequests[i].VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.Deposit = financeRequests[i].Parameters.Deposit;
                        }
                        if (typeof product.OverrideFinanceParameters.DepositType == 'undefined') {
                            financeRequests[i].VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.DepositType = financeRequests[i].Parameters.DepositType;
                        }
                        if (typeof product.OverrideFinanceParameters.AnnualMileage == 'undefined') {
                            financeRequests[i].VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.AnnualMileage = financeRequests[i].Parameters.AnnualMileage;
                        }
                        if (typeof product.OverrideFinanceParameters.IsTelematics == 'undefined') {
                            financeRequests[i].VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.IsTelematics = financeRequests[i].Parameters.IsTelematics;
                        }
                    });
                })
            }

        }
        return financeRequests;
    }

    setVehiclesAsLoading() {
        for (let i = 0, len = this.usedVehicles.length; i < len; i++) {
            this.usedVehicles[i].finance = 'loading';
        }
    }

    setVehiclesAsFailed() {
        for (let i = 0, len = this.usedVehicles.length; i < len; i++) {
            this.usedVehicles[i].finance = false;
        }
    }

    /**
     * Get the original vehicle ID from the CW Id
     * @param {String} cwId
     */
    getVehicleIdFromCodeweaversId(cwId) {
        const pos = cwId.indexOf('_');
        if (pos <= 0) {
            return cwId;
        }
        return cwId.slice(0, pos);
    }

    getFinance() {
        // this.storeFinance();
        let financeRequests = this.getFinanceRequests();
        this.setVehiclesAsLoading();

        // Create an array of the requests that will be needed
        let promises = [];
        for (let i = 0; i < financeRequests.length; i += 1) {
            promises.push(axios({
                method: 'POST',
                url: 'https://services.codeweavers.net/public/v3/JsonFinance/Calculate',
                headers: {
                    'X-CW-ApiKey': 'ONH75GHd8x0gu6yfJ6',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                data: financeRequests[i]
            }));
        }

        // Return a promise so we can do logic in Vue after all requests finish
        return new Promise((resolve, reject) => {
            // Use Promise.all with axios to only call .then or .error once all requests have completed
            axios.all(promises)
                .then(results => {
                    // If there's a global error, then set the finance part of each used vehicle to false
                    // if (typeof results[i].data.HasError !== 'undefined' && results[i].data.HasError == true) {
                    //     this.setVehiclesAsFailed();
                    //     reject(this.usedVehicles);
                    // }
                    // First pass through results to recombine quotes, because different finance keys might be submitted as separate vehicles due to the vehicle price varying based on the key
                    let recombinedResults = {};
                    for (let i = 0, len = results.length; i < len; i += 1) {
                        if (typeof results[i].data.VehicleResults == 'undefined') {
                            continue;
                        }
                        for (let j = 0, sublen = results[i].data.VehicleResults.length; j < sublen; j += 1) {
                            // Get the original vehicle ID
                            let vehicleResult = results[i].data.VehicleResults[j];

                            let vehicleResultId = vehicleResult.Id || false;
                            if (vehicleResultId === false) {
                                console.error('Unkonwn vehicleResultId', vehicleResult);
                                continue;
                            }

                            vehicleResultId = this.getVehicleIdFromCodeweaversId(vehicleResultId);

                            if (typeof recombinedResults[vehicleResultId] == 'undefined') {
                                recombinedResults[vehicleResultId] = vehicleResult;
                                continue;
                            }
                            recombinedResults[vehicleResultId].FinanceProductResults = [
                                ...recombinedResults[vehicleResultId].FinanceProductResults,
                                ...vehicleResult.FinanceProductResults
                            ];
                        }
                    }
                    for (let i = 0, len = this.usedVehicles.length; i < len; i += 1) {
                        if (typeof recombinedResults[this.usedVehicles[i].id] == 'undefined') {
                            // Promo card doesn't need finance. Detecting if it's a promo card by checking if the vat_price key exists
                            if (typeof this.usedVehicles[i].vat_price == 'undefined') {
                                continue;
                            }
                            this.setVehicleAsFailed(this.usedVehicles[i].id);
                            console.error("Couldn't find finance for id", this.usedVehicles[i].id, recombinedResults);
                            continue;
                        }
                        this.updateVehicleById(this.usedVehicles[i].id, { finance: recombinedResults[this.usedVehicles[i].id]});
                    }
                    // for (let i = 0, len = recombinedResults.length; i < len; i += 1) {
                    //     // Step through the results and update our source data
                    //     for (let j = 0, len = results[j].data.VehicleResults.length; j < len; j++) {
                    //         this.updateVehicleById(results[i].data.VehicleResults[j].Id, { finance: results[i].data.VehicleResults[j]});
                    //     }
                    // }

                    resolve(this.usedVehicles);
                })
                .catch(error => {
                    console.error('UsedVehicleFinance@getFinance error', error);
                    this.setVehiclesAsFailed();
                    reject(this.usedVehicles);
                });
        });
    }
}